export default "__VITE_ASSET__BZ6iuf6Q__"